import { FeatureObject } from "@eg-maps/core";
import { MapMarker, MarkerType } from "./typings";

type FormatTextFunc = (key: string, ...args: any[]) => string;

/* istanbul ignore next */
export const addAriaLabelsToMarker = (marker: FeatureObject, formatText: FormatTextFunc) =>
  (marker.ariaLabels = {
    default: formatText("egmaps.markers.unselected.a11yLabel", marker.name) || `${marker.name} marker`,
    onSelect: formatText("egmaps.markers.selected.a11yLabel", marker.name) || `${marker.name} marker selected`,
  });

export const convertToEgMapsMarkers = (mapMarkers: MapMarker[], formatText: FormatTextFunc): FeatureObject[] =>
  mapMarkers.map((marker) => {
    const featureType = marker.cardContent.type === MarkerType.HOTEL ? "property" : "place";
    const newMarker: FeatureObject = {
      id: marker.cardContent.id,
      lat: marker.position.lat,
      lng: marker.position.lng,
      name: marker.cardContent.title,
      text: marker.cardContent.price || "",
      type: featureType,
      status: "unknown",
      qualifiers: marker.qualifiers,
    };

    addAriaLabelsToMarker(newMarker, formatText);

    return newMarker;
  });
